import { inject, Injectable } from '@angular/core';
import { DataTestService } from '@y42/data-test';
import { DatasourceTableStoreModel } from '@y42/datasource';
import { IntegrationTableService } from '../datasource-table/integration-table.service';

@Injectable({ providedIn: 'root' })
export class IntegrationDataTestService extends DataTestService<DatasourceTableStoreModel> {
  constructor() {
    super(inject(IntegrationTableService));
  }
}
